import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { PolicyType } from "../modals/PolicyModal";
import Storage from "../../utilities/storage/StorageFunctions";
import Constants from "../../utilities/Constants";
import { getUnique } from "../../utilities/HelperFunctions";

export interface PolicySliceType {
  policies: PolicyType[];
  policyNumber: string;
  isLoading: boolean;
}
const initialState: PolicySliceType = {
  policies: [],
  policyNumber: "",
  isLoading: false,
};

export const policySlice = createSlice({
  name: "Policy",
  initialState,
  reducers: {
    updatePolicy: (state, action: PayloadAction<PolicyType[]>) => {
      const combinedPolicies = [...state.policies, ...action.payload];
      const uniquePolicies = getUnique(
        combinedPolicies,
        "policyNumber"
      ) as PolicyType[];
      state.policies = uniquePolicies;
    },
    setCurrentPolicyNumber: (state, action: PayloadAction<string>) => {
      state.policyNumber = action.payload;
      Storage.storeData(
        Constants.LocalStoreConstant.SELECTED_POLICY_NUMBER,
        action.payload
      );
    },
    toogleLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    resetPolicies: () => initialState,
  },
});

export const {
  updatePolicy,
  resetPolicies,
  setCurrentPolicyNumber,
  toogleLoading,
} = policySlice.actions;

export default policySlice.reducer;
